import type { CSID, EventType } from './tracify.contracts';

export const CSID_MARKETING: CSID = 'f76edf37-4711-409c-b99f-75e5f96afe40' as CSID;
export const CSID_WEBSHOP: CSID = '86fdb904-c465-4d96-9a47-f6bd4851bbcc' as CSID;

/**
 * A map defining which CSIDs should be used when a given Tracify method gets called.
 */
export const EVENT_TYPE_TO_CSIDS_MAP: Record<EventType, CSID[]> = {
  captureAddToCart: [],
  captureConversion: [CSID_MARKETING],
  capturePageView: [CSID_MARKETING, CSID_WEBSHOP],
};
